import { Phone } from "lucide-react";
import { SHOP, waLink } from "@/lib/shop";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Footer = () => (
  <footer className="bg-ink text-slate-300 pb-24 md:pb-0" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <p className="font-display text-2xl font-black text-white">FONZ <span className="text-brand">FIX</span>4<span className="text-brand">U</span></p>
        <p className="mt-3 text-sm max-w-xs">Tech repair specialist — mobile phone sales & repairs in Dungannon, Northern Ireland.</p>
      </div>
      <div className="text-sm space-y-2">
        <p className="font-bold text-white">Shop</p>
        <a href="#phones" className="block hover:text-white">iPhones & Samsung phones</a>
        <a href="#phones" className="block hover:text-white">Tablets & accessories</a>
        <a href="#repairs" className="block hover:text-white">Phone, tablet & laptop repairs</a>
      </div>
      <div className="text-sm space-y-2">
        <p className="font-bold text-white">Contact</p>
        <p>{SHOP.address}</p>
        <a href={`tel:${SHOP.phoneTel}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-call-link"><Phone className="h-4 w-4" /> {SHOP.phoneDisplay}</a>
        <a href={waLink("Hi FONZ FIX4U, I have a question.")} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white" data-testid="footer-whatsapp-link"><WhatsAppIcon className="h-4 w-4" /> WhatsApp</a>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} FONZ FIX4U · <a href="/admin" className="hover:text-slate-300" data-testid="footer-admin-link">Shop login</a>
    </div>
  </footer>
);
